
import { Project } from "../../classes"

const ProjectModule = {
  namespaced: true,
  state: {
    occRateData: [],
  },
  actions: {
    updateProject: async ({ }, payload) => {
      try {
        const data = await Project.updateProject(payload);
        return data;
      } catch (err) {
        return false;
      }
    },
    getProjectOverAllWithPreviousData: async ({  }, payload) => {
      try {
        const data = await Project.getProjectOverAllWithPreviousData({
          projectId: payload.projectId,
          marketId: payload.marketId,
          startDate :payload.startDate,
          endDate  :payload.endDate
        });
        return data;
      } catch (err) {
        throw err
      }
    },
    getProject: async ({ }, payload) => {
      try {
        const data = await Project.getProject({
          id: payload.projectId
        });
        return data;
      } catch (err) {
        throw err;
      }
    },
  },
  getters: {},
  mutations: {
  },
};
export default ProjectModule;
